import { Box, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../Components/Input';
import logo from '../Images/login.png';
import { loginUser } from '../Redux-store/userActions';
import '../Styles/Login.css';

function Login() {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  // const [errorMessage, setErrorMessage] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.user);

  const handleLoginEvent = async (e) => {
    e.preventDefault();
    let userCredentials = {
      userName,
      password,
    };

    try {
      await dispatch(loginUser(userCredentials));
      setUserName('');
      setPassword('');
      navigate('/home');
    } catch (error) {
      // setErrorMessage("Login Failed!. Please check your credentials!");
    }
  };

  return (
    <div className='loginPage'>
      <div className='container'>
        <figure>
          <img src={logo} alt='logo' />
        </figure>
        <Input
          type='text'
          placeholder='Enter Username'
          name='userName'
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />
        <Box position='relative'>
          <Input
            type={showPassword ? 'text' : 'password'}
            placeholder='Enter Password'
            name='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: '-webkit-fill-available',
            }}
          />
          <IconButton
            sx={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-30%)',
            }}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </IconButton>
        </Box>
        <div className='remember-container'>
          <div className='remember'>
            <input type='checkbox' />
            <p>Remember me</p>
          </div>
          {/* <Link
            href='/forget'
            onClick={(e) => {
              e.preventDefault();
              navigate('/forget');
            }}
          >
            Forget Password ?
          </Link> */}
          {/* <MuiLink className="" style={{
            cursor: "pointer",
            '&:hover': {
              color: "blue"
            }
          }}

            onClick={() => navigate("/forget")}
          >Forgot Password?<MuiLink /> */}
        </div>
        {error && <p className='error-message'>{error}</p>}

        <Link to='/'>
          <button onClick={handleLoginEvent}>
            {loading ? '...Loading' : 'Login'}
          </button>
        </Link>
      </div>
    </div>
  );
}

export default Login;
